// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_518cef', '__Roboto_Fallback_518cef'","fontStyle":"normal"},"className":"__className_518cef"};